import React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import { withStyles } from '@material-ui/core';
import PricingPlans from '../../Components/ProductRegistration/PricingPlans';

const styles = theme => ({});

function Account({ classes }) {
  return (
    <Page>
      <Container component="main" maxWidth="lg">
        <Typography variant="h1">Pricing Plans</Typography>
        <PricingPlans />
      </Container>
    </Page>
  );
}

export default withStyles(styles)(Account);
